import React, { useState } from 'react'
import { mergeLeft } from 'merge-left-utils'

import { Input } from 'rsuite'

import './ProductSearchPriceFilter.scss'

interface ProductSearchPriceFilterState extends Record<string, any> {
  gt: number | null
  lt: number | null
}

const priceFilterStateShape: ProductSearchPriceFilterState = {
  gt: null,
  lt: null
}

const _placeholders: Record<string, string> = {
  gt: 'От',
  lt: 'До'
}
export interface ProductSearchPriceFilterProps {
  value: ProductSearchPriceFilterState
  onChange: (newPrices: ProductSearchPriceFilterState) => void
}

export default function ProductSearchPriceFilter ({
  value,
  onChange
}: ProductSearchPriceFilterProps) {
  const [ prices, setPrices ] = useState<ProductSearchPriceFilterState>(
    mergeLeft(priceFilterStateShape, value)
  )

  const handlePricesChange = (key: string) => (value: any) => {
    const parsedPrice = parseFloat(value)
    const newPrices = mergeLeft(prices, {
      [key]: isNaN(parsedPrice) ? null : parsedPrice
    })

    setPrices(newPrices)
    onChange(newPrices)
  }

  return (
    <div className="ProductSearchPriceFilter">
      {Object.keys(prices).map((key) => (
        <Input
          key={`productSearchPriceFilter:${key}`}
          inputMode="numeric"
          className="ProductSearchPriceFilter__InputBlock"
          inputClassName="ProductSearchPriceFilter__Input"
          value={prices[key] && prices[key] > 0 ? prices[key] : null}
          onChange={handlePricesChange(key)}
          placeholder={_placeholders[key]}
          size="xs"
        />
      ))}
    </div>
  )
}
